module.exports = __webpack_public_path__ + "static/media/customer_graphics_vl_logo_without_leaf.54198f45.svg";